import { Component, OnInit, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { LoginService } from '../Shared/Service/login_service';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { interval } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import beautify from 'xml-beautifier';
declare var $: any; 
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  propertyName: any;
  version: any;
  // hotelName: any;
  hotelip: any;
  fnSrvSts: any;
  createdatetime:any
}
@Component({
  selector: 'app-qatarlogsnew',
  templateUrl: './qatarlogsnew.component.html',
  styleUrls: ['./qatarlogsnew.component.css'],
  providers: [LoginService,
      {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
      },
  
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class QatarlogsnewComponent implements OnInit {
  selectedDate: any = new Date();
  selectedTOODate: any = new Date();
  selectedDeptItems: any;
  Userid: any = [];
  apiresult: any;
  hotellistproperty: any;
  dropdownDeptData: any
  isProgressing: Boolean = false;
  dropdownSettingsDept: IDropdownSettings = {};
  searchBarFilter: boolean = false;
  searchText = "";
  errorMessage: string;
  errorMsgSubscription: boolean;
  public Pmscodevalue: any;
  hotelSearchDataStatus: any;
  heartBeatData: any;
  productType: any;
  displayContent: boolean;
  currentDateStore: any;
  blinkOfflineHotel: boolean;
  storeHeartBeatValue: any;
  excelFunction: boolean = false;
  public PGF: any = 0;
  public PGT: any = 50;
  pageSize = 50;
  requestPayload: any;
  dataSource: MatTableDataSource<idsProductList>
  StorelstRestr: any;
  totalcount: any = 0;
  filterProperty: any
  idsProductList: idsProductList[] = [];
  XMLName: any;
  status: void;
  defaultData: any;
  display: Boolean = false;
  Val: string;
  today = new Date();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(private apiCallIdsService: DashboarduiService,private toastr: ToastrService,private datePipe: DatePipe) { }
  displayedColumns: string[] = ['echoToken','eventType','gstnam', 'resnub','srlnub','regnub',
    'requestDateTime','attachment','exesta','source','Request','Response','FxRequest']//

    hideSearchFilter(){
      this.Val = '';
      this.searchBarFilter = false
    }
  ngOnInit() {
    this.isProgressing = true;
    this.callIDSUsersProperties();
    this.dropdownSettingsDept = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }
  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getnewqatarproperties()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          this.apiresult = data;
          this.hotellistproperty = this.apiresult;
          this.dropdownDeptData = this.apiresult;
          console.log('Property 113 = ', data)
          this.isProgressing = false;
        });
  }
  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if (this.selectedDeptItems) {
      this.searchBarFilter = false
      this.searchText = '';
      if (this.selectedDeptItems.length > 0) {
        console.log('if condition')
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)
        this.errorMsgSubscription = true
        //this.errorMessage = "Please select property and load"
        this.displayContent = true
        // For Online Status
        this.apiCallIdsService
          .readHotelSearch(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHotelSearch =', data)
            this.hotelSearchDataStatus = data[0].recordstatus
            this.productType = data[0].producttype
          });
        this.apiCallIdsService
          .readHeartbeat(this.Pmscodevalue)
          .subscribe((data) => {
            console.log('readHeartbeat =', data[0])
            this.heartBeatData = data[0].heartBeat
  
            // For blinking the record
            const today = new Date()
            console.log('Today Date = ', today);
            this.currentDateStore = today.toLocaleTimeString('it-IT')
            console.log('Today Date = ', this.currentDateStore);
            this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
            var start = this.storeHeartBeatValue.split(":");
            var end = this.currentDateStore.split(":");
            var startDate = new Date(0, 0, 0, start[0], start[1], 0);
            var endDate = new Date(0, 0, 0, end[0], end[1], 0);
            var diff = endDate.getTime() - startDate.getTime();
            var hours = Math.floor(diff / 1000 / 60 / 60);
            diff -= hours * 1000 * 60 * 60;
            var minutes = Math.floor(diff / 1000 / 60);
            // console.log('minutes difference',minutes)
            console.log('minutes difference', hours + ":" + minutes)
            if ((hours + ":" + minutes) > "0:30") {
              console.log('blinkOfflineHotel true')
              this.blinkOfflineHotel = true
            } else {
              console.log('blinkOfflineHotel false')
              this.blinkOfflineHotel = false
            }
          });
        interval(2000 * 60).subscribe(() => {
          this.heartbeatFunction();
        });
      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
       // this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.excelFunction = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }
  
  heartbeatFunction() {
    this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =', data[0])
        this.heartBeatData = data[0].heartBeat
      });
  }
  GetParseonlyDateTime(d: any) {
    console.log('GetParseonlyDateTime call', d.substring(12))
    return (d.substring(12));
  }
  readQatarLogNew() {
    this.searchBarFilter = true
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');
    }
    else {
      this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
      this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
      this.isProgressing = true;
      // this.PGF = 0;
      // this.PGT = 50;
      console.log('pageSize == ',this.pageSize)
      console.log('PGF == ',this.PGF)
      console.log('PGT == ',this.PGT)
      console.log('selectedDate == ',this.selectedDate)
      console.log('selectedTOODate == ',this.selectedTOODate)
      this.requestPayload = {
        "PMSCODE": this.Pmscodevalue,
        "FRMDATE": this.selectedDate,
        "TOODATE": this.selectedTOODate
      } 
      console.log("this.requestPayload ==", this.requestPayload)
      this.apiCallIdsService.readnewQatarLogsData(this.requestPayload)
        .subscribe((res) => {
          this.StorelstRestr = res;
          console.log("length",this.StorelstRestr)
          this.totalcount=this.StorelstRestr.length;
          if (this.totalcount < 1) {
            this.toastr.error('No Data Found');
            console.log(this.totalcount)
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.displayContent = false
            this.excelFunction = false
            this.isProgressing = false;
  
          } else {
            this.idsProductList = res;
            console.log('response ==',this.StorelstRestr)
            //this.totalcount = this.StorelstRestr.length;
            console.log('totalcount ==',this.totalcount)
            this.errorMsgSubscription = false
            this.displayContent = true
            this.excelFunction = true
            this.filterProperty = this.idsProductList
            this.dataSource = new MatTableDataSource(this.idsProductList);
            this.dataSource.paginator = this.paginator;
            this.toastr.success('Data loaded Successfully');
            this.isProgressing = false;
          }
        });
    }
  }
  showXml(token: any, xmltype: any) {
    
    this.status = this.LoadXML(token, xmltype);
}
/* LoadXML(token: any,xmltype: any) {
  this.isProgressing = true;
  console.log('token',token);
  console.log('xmltype',xmltype);
  this.apiCallIdsService.readnewQatarLogsXML( token, xmltype)
    .subscribe(data => {
      if (data.length < 1) {
        this.toastr.error('No data to load');
      }else{
        const json = beautify(data[0].jsonData);
        console.log(json);
        if(xmltype == 'Request'){
          this.XMLName = "Request"
        }else{
          this.XMLName = "Response"
        }
        this.defaultData = json;
        this.display = true;
        this.isProgressing = false;
      }       
    },
      error => {
        this.toastr.error("Falied to load requests !");
        this.isProgressing = false;
      },

    );
} *///Indhuja 10-04-2025 Change the Load xml method bcoz we want to download the file some files
    LoadXML(token: any, xmltype: any) {
      this.isProgressing = true;
      this.apiCallIdsService.readnewQatarLogsXML(token, xmltype)
        .subscribe(data => {
          if (data.length < 1) {
            this.toastr.error('No data to load');
            this.isProgressing = false;
            return;
          }
    
          const rawData = data[0].jsonData;
          const downloadURLPattern = /https:\/\/datahub\.blob\.core\.windows\.net\/qatarlogs\/.*\.JSON/i;
    
          if (downloadURLPattern.test(rawData)) {
            // Trigger download
            const link = document.createElement('a');
            link.href = rawData;
            link.download = 'QatarRequestDownload.json';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.isProgressing = false;
            return;
          }
    
          // Otherwise show the beautified XML in the modal
          const beautified = beautify(rawData);
          this.XMLName = xmltype === 'Request' ? 'Request' : 'Response';
          this.defaultData = beautified;
          this.display = true;
          this.isProgressing = false;
        }, error => {
          this.toastr.error("Failed to load requests!");
          this.isProgressing = false;
        });
    }
closeModalDialog() {
  this.display = false; //set none css after close dialog
}
Search(event: any) {
  console.log('event= ', event)
  this.dataSource = this.filterProperty.filter((res: { echoToken: { toString: () => string; };
  resnub: { toString: () => string; } ;regnub:{toString:()=>string};gstnam:{toString:()=>string}}) => {
    return res.echoToken.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) 
    || res.resnub.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    ||res.echoToken.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    ||res.regnub.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    ||res.gstnam.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
  });
  if (event == '') {
    this.Val = '';
  }
}
}


